var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVendor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0C0.895431 0 0 0.89543 0 2V22C0 23.1046 0.89543 24 2 24H22C23.1046 24 24 23.1046 24 22V2C24 0.895431 23.1046 0 22 0H16V1V4C16 5.10457 15.1046 6 14 6H10C8.89543 6 8 5.10457 8 4V1V0H2ZM7 9H11.5V9.74074H10.75V17.5185C10.75 18.3367 10.0784 19 9.25 19C8.42157 19 7.75 18.3367 7.75 17.5185V9.74074H7V9ZM8.125 12.7037H10.375V17.5185C10.375 18.1322 9.87132 18.6296 9.25 18.6296C8.62868 18.6296 8.125 18.1322 8.125 17.5185V12.7037ZM12.5 9H17V9.74074H16.25V17.5185C16.25 18.3367 15.5784 19 14.75 19C13.9216 19 13.25 18.3367 13.25 17.5185V9.74074H12.5V9ZM13.625 14.5H15.875V17.5185C15.875 18.1322 15.3713 18.6296 14.75 18.6296C14.1287 18.6296 13.625 18.1322 13.625 17.5185V14.5ZM15 1H9V4C9 4.55228 9.44772 5 10 5H14C14.5523 5 15 4.55228 15 4V1ZM20 20H4V21H20V20Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendor);
export default __webpack_public_path__ + "static/media/Vendor.13c53b6b9c538ca44376d717fa7cf818.svg";
export { ForwardRef as ReactComponent };